import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import DetailHero from '../components/sections/DetailHero';
import DetailStory from '../components/sections/DetailStory';
import DetailContact from '../components/sections/DetailContact';
import LoadingMascot from '../components/LoadingMascot';
import { usePet } from '../hooks/usePet';
import '../styles/AdotarDetail.css';

const AdotarDetail: React.FC = () => {
  const { id = '' } = useParams<{ id: string }>();
  const { pet, loading, notFound, error } = usePet(id);

  // Bring the user to the top whenever they land on a fresh detail.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [id]);

  if (loading) {
    return (
      <LoadingMascot
        className="adotar-detail__placeholder"
        label="a abrir a ficha…"
      />
    );
  }

  if (notFound) {
    return (
      <div className="adotar-detail__missing">
        <div className="adotar-detail__missing-kind">— uma nota</div>
        <h1>Ficha não encontrada</h1>
        <p>
          Talvez já tenha encontrado casa, ou o link tenha mudado.
          Volta ao caderno e folheia as outras fichas.
        </p>
        <div className="adotar-detail__missing-cta">
          <Link to="/adotar">← voltar ao caderno</Link>
        </div>
      </div>
    );
  }

  if (error || !pet) {
    return (
      <div className="adotar-detail__missing">
        <div className="adotar-detail__missing-kind">— uma nota</div>
        <h1>Algo correu mal a abrir esta ficha.</h1>
        <p>Tenta de novo daqui a um bocado, ou liga-nos diretamente.</p>
        <div className="adotar-detail__missing-cta">
          <Link to="/adotar">← voltar ao caderno</Link>
        </div>
      </div>
    );
  }

  return (
    <article className="adotar-detail">
      <DetailHero pet={pet} />
      <DetailStory pet={pet} />
      <DetailContact pet={pet} />
    </article>
  );
};

export default AdotarDetail;
